import { useContext, useState } from 'react'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import classNames from 'classnames'

import ChildSocialFeatureSettings from '../../common/ChildSocialFeatureSettings/ChildSocialFeatureSettings'
import { AccountContext } from '../AccountContext'

import classes from './PrivacySettingsForm.module.scss'

const PrivacySettingsForm = () => {
  const dispatch = useDispatch()
  const { user, submitDisabled, updateAction } = useContext(AccountContext)

  const settings = user?.user_settings || {}
  const initialContent = settings.allow_posting_content ?? true
  const initialComments = settings.allow_posting_comments ?? true

  const [allowPostingContent, setAllowPostingContent] = useState(initialContent)
  const [allowPostingComments, setAllowPostingComments] = useState(initialComments)
  const [isUpdating, setIsUpdating] = useState(false)

  const hasChanges = allowPostingContent !== initialContent || allowPostingComments !== initialComments

  const handleSubmit = async (e) => {
    e.preventDefault()

    const partialUser = {
      id: user.id,
      ...(settings.id && { 'user_setting_attributes[id]': settings.id }),
      'user_setting_attributes[allow_posting_content]': allowPostingContent,
      'user_setting_attributes[allow_posting_comments]': allowPostingComments,
    }

    try {
      setIsUpdating(true)
      const newState = await dispatch(updateAction(partialUser))

      if (newState.type === 'UI_ERROR') {
        if (newState.status === 503) {
          toast.error('Updating privacy settings is currently unavailable.')
        } else {
          toast.error('Couldn\'t update privacy settings. Please try again later.')
        }
      } else {
        toast.success('Privacy settings have been successfully updated!')
      }
    } catch {
      toast.error('Couldn\'t update privacy settings. Please try again later.')
    } finally {
      setIsUpdating(false)
    }
  }

  return (
    <form onSubmit={handleSubmit} className={classNames(classes.container, 'animated fadeIn')}>
      <div className='row'>
        <h4 className={classes.title}>Privacy Settings</h4>
      </div>

      <ChildSocialFeatureSettings
        allowPostingContent={allowPostingContent}
        allowPostingComments={allowPostingComments}
        onChangePostingContent={setAllowPostingContent}
        onChangePostingComments={setAllowPostingComments}
      />

      <div className='row mt-5'>
        <button
          type='submit'
          className='btn btn-primary'
          disabled={isUpdating || submitDisabled || !hasChanges}
        >
          Sav{isUpdating ? 'ing' : 'e'} Changes
        </button>
      </div>
    </form>
  )
}

export default PrivacySettingsForm
